import React from 'react';
import { PageWrapper, Paper } from 'virtues-bootstrap';
import PrivacyPolicyText from 'components/PrivacyPolicyText';

const PrivacyPolicy = () => (
  <PageWrapper>
    <h1>Privacy Policy</h1>
    <Paper>
      <PrivacyPolicyText scroll={false} />
    </Paper>
  </PageWrapper>
);

export default PrivacyPolicy;
